export const PRICING_LANGUAGES = ['en', 'tr', 'es', 'fr', 'de', 'pt', 'ar'];

const localized = (en, tr, es, fr, de, pt, ar) => ({
  en,
  tr,
  es,
  fr,
  de,
  pt,
  ar,
});

export const DEFAULT_PRICES = {
  packages: {
    LAUNCH: 1490,
    BUILD: 2990,
    SCALE: 5990,
    CUSTOM: 890,
  },
  modules: {
    'Smart website chat': 290,
    'Business-trained chat': 370,
    'WhatsApp auto replies': 190,
    'Lead qualification system': 290,
    'Online booking': 190,
    'Online payments': 290,
    'Quote system': 190,
    'Extra language': 190,
    'Country-specific SEO': 290,
    'Google Reviews': 150,
    'Instagram feed': 120,
    'Speed optimization': 190,
  },
  plans: {
    CARE: 79,
    GROWTH: 149,
    'BUSINESS PRO': 299,
  },
};

export const CATEGORY_CONTENT = {
  'Customer Engagement': localized(
    'Customer Engagement',
    'Müşteri İletişimi',
    'Comunicación con Clientes',
    'Communication Client',
    'Kundenkommunikation',
    'Comunicação com Clientes',
    'التواصل مع العملاء'
  ),
  Sales: localized('Sales', 'Satış', 'Ventas', 'Ventes', 'Vertrieb', 'Vendas', 'المبيعات'),
  Global: localized('Global', 'Global', 'Global', 'International', 'Global', 'Global', 'عالمي'),
  Visibility: localized(
    'Visibility & Performance',
    'Görünürlük ve Performans',
    'Visibilidad y Rendimiento',
    'Visibilité et Performance',
    'Sichtbarkeit und Leistung',
    'Visibilidade e Desempenho',
    'الظهور والأداء'
  ),
};

export const PACKAGE_CONTENT = {
  LAUNCH: {
    name: localized('LAUNCH', 'BAŞLANGIÇ', 'LANZAMIENTO', 'LANCEMENT', 'START', 'LANÇAMENTO', 'الانطلاق'),
    target: localized(
      'For small businesses and brands ready to make a professional digital start.',
      'Küçük işletmeler ve profesyonel bir dijital başlangıç yapmak isteyen markalar için.',
      'Para pequeñas empresas y marcas listas para dar un comienzo digital profesional.',
      'Pour les petites entreprises et les marques prêtes à démarrer leur présence numérique de manière professionnelle.',
      'Für kleine Unternehmen und Marken, die professionell digital starten möchten.',
      'Para pequenas empresas e marcas prontas para começar no digital de forma profissional.',
      'للشركات الصغيرة والعلامات التجارية المستعدة لبداية رقمية احترافية.'
    ),
    impacts: [
      localized('Professional appearance', 'Profesyonel görünüm', 'Imagen profesional', 'Image professionnelle', 'Professioneller Auftritt', 'Aparência profissional', 'مظهر احترافي'),
      localized('Strong mobile experience', 'Güçlü mobil deneyim', 'Experiencia móvil sólida', 'Expérience mobile performante', 'Starkes mobiles Erlebnis', 'Excelente experiência móvel', 'تجربة جوال قوية'),
      localized('More contact requests', 'Daha fazla iletişim talebi', 'Más solicitudes de contacto', 'Plus de demandes de contact', 'Mehr Kontaktanfragen', 'Mais pedidos de contato', 'المزيد من طلبات التواصل'),
      localized('Fast and reliable infrastructure', 'Hızlı ve güvenilir altyapı', 'Infraestructura rápida y fiable', 'Infrastructure rapide et fiable', 'Schnelle und zuverlässige Infrastruktur', 'Infraestrutura rápida e confiável', 'بنية تحتية سريعة وموثوقة'),
    ],
  },
  BUILD: {
    name: localized('BUILD', 'GELİŞTİRME', 'CRECIMIENTO', 'DÉVELOPPEMENT', 'AUFBAU', 'CRESCIMENTO', 'البناء'),
    target: localized(
      'For growing businesses that want more leads, bookings and easier management.',
      'Daha fazla müşteri adayı, rezervasyon ve yönetim kolaylığı isteyen büyüyen işletmeler için.',
      'Para empresas en crecimiento que buscan más clientes potenciales, reservas y una gestión más sencilla.',
      'Pour les entreprises en croissance qui veulent plus de prospects, de réservations et une gestion simplifiée.',
      'Für wachsende Unternehmen, die mehr Leads, Buchungen und einfachere Abläufe möchten.',
      'Para empresas em crescimento que querem mais leads, reservas e facilidade de gestão.',
      'للشركات النامية التي تريد مزيدًا من العملاء المحتملين والحجوزات وإدارة أسهل.'
    ),
    impacts: [
      localized('More bookings', 'Daha fazla rezervasyon', 'Más reservas', 'Plus de réservations', 'Mehr Buchungen', 'Mais reservas', 'المزيد من الحجوزات'),
      localized('Easier content management', 'Daha kolay içerik yönetimi', 'Gestión de contenido más sencilla', 'Gestion de contenu simplifiée', 'Einfachere Inhaltsverwaltung', 'Gestão de conteúdo mais simples', 'إدارة محتوى أسهل'),
      localized('Better customer tracking', 'Daha iyi müşteri takibi', 'Mejor seguimiento de clientes', 'Meilleur suivi client', 'Bessere Kundenverfolgung', 'Melhor acompanhamento de clientes', 'متابعة أفضل للعملاء'),
      localized('Less manual work', 'Daha az manuel iş', 'Menos trabajo manual', 'Moins de travail manuel', 'Weniger manuelle Arbeit', 'Menos trabalho manual', 'عمل يدوي أقل'),
      localized('CRM integration and advanced SEO included', 'CRM entegrasyonu ve gelişmiş SEO dahil', 'Integración CRM y SEO avanzado incluidos', 'Intégration CRM et SEO avancé inclus', 'CRM-Integration und erweitertes SEO inklusive', 'Integração com CRM e SEO avançado incluídos', 'يشمل تكامل CRM وتحسين محركات البحث المتقدم'),
    ],
  },
  SCALE: {
    name: localized('SCALE', 'ÖLÇEKLEME', 'ESCALA', 'ÉVOLUTION', 'SKALIERUNG', 'ESCALA', 'التوسع'),
    target: localized(
      'For businesses that need CRM, automation, advanced admin tools and custom integrations.',
      'CRM, otomasyon, gelişmiş yönetim araçları ve özel entegrasyonlar isteyen işletmeler için.',
      'Para empresas que necesitan CRM, automatización, herramientas avanzadas de administración e integraciones personalizadas.',
      'Pour les entreprises qui ont besoin d’un CRM, d’automatisations, d’outils de gestion avancés et d’intégrations sur mesure.',
      'Für Unternehmen, die CRM, Automatisierung, erweiterte Verwaltung und individuelle Integrationen benötigen.',
      'Para empresas que precisam de CRM, automação, ferramentas avançadas de gestão e integrações personalizadas.',
      'للشركات التي تحتاج إلى CRM والأتمتة وأدوات إدارة متقدمة وتكاملات مخصصة.'
    ),
    impacts: [
      localized('Automate operations', 'Operasyonları otomatikleştirme', 'Automatizar operaciones', 'Automatiser les opérations', 'Abläufe automatisieren', 'Automatizar operações', 'أتمتة العمليات'),
      localized('Reduce customer losses', 'Müşteri kayıplarını azaltma', 'Reducir la pérdida de clientes', 'Réduire la perte de clients', 'Kundenverluste reduzieren', 'Reduzir a perda de clientes', 'تقليل فقدان العملاء'),
      localized('Reduce team workload', 'Ekip iş yükünü düşürme', 'Reducir la carga del equipo', 'Réduire la charge de l’équipe', 'Teamaufwand reduzieren', 'Reduzir a carga da equipe', 'تقليل عبء عمل الفريق'),
      localized('Data-driven growth', 'Veriye dayalı büyüme', 'Crecimiento basado en datos', 'Croissance pilotée par les données', 'Datenbasiertes Wachstum', 'Crescimento orientado por dados', 'نمو قائم على البيانات'),
      localized('CRM integration and advanced SEO included', 'CRM entegrasyonu ve gelişmiş SEO dahil', 'Integración CRM y SEO avanzado incluidos', 'Intégration CRM et SEO avancé inclus', 'CRM-Integration und erweitertes SEO inklusive', 'Integração com CRM e SEO avançado incluídos', 'يشمل تكامل CRM وتحسين محركات البحث المتقدم'),
    ],
  },
  CUSTOM: {
    name: localized('CUSTOM', 'ÖZEL', 'PERSONALIZADO', 'SUR MESURE', 'INDIVIDUELL', 'PERSONALIZADO', 'مخصص'),
    target: localized(
      'Choose only the capabilities your business needs and build a tailored system.',
      'Yalnızca işletmenizin ihtiyaç duyduğu özellikleri seçin ve size özel bir sistem oluşturun.',
      'Elige solo las capacidades que necesita tu negocio y crea un sistema a medida.',
      'Choisissez uniquement les capacités utiles à votre entreprise et créez un système sur mesure.',
      'Wählen Sie nur die Funktionen, die Ihr Unternehmen braucht, und erstellen Sie ein passendes System.',
      'Escolha apenas os recursos de que sua empresa precisa e monte um sistema sob medida.',
      'اختر فقط الإمكانات التي يحتاجها عملك وابنِ نظامًا مخصصًا.'
    ),
  },
};

export const MODULE_CONTENT = {
  'Smart website chat': {
    name: localized('Smart Website Chat', 'Akıllı Web Sitesi Sohbeti', 'Chat Inteligente para el Sitio', 'Chat Intelligent pour Site Web', 'Intelligenter Website-Chat', 'Chat Inteligente para Site', 'دردشة ذكية للموقع'),
    impact: localized('Capture More Leads', 'Daha Fazla Müşteri Adayı Topla', 'Capta Más Clientes Potenciales', 'Captez Plus de Prospects', 'Mehr Leads Gewinnen', 'Capture Mais Leads', 'اجمع المزيد من العملاء المحتملين'),
  },
  'Business-trained chat': {
    name: localized('Business-Trained Chat', 'İşletmeye Özel Eğitilmiş Sohbet', 'Chat Entrenado para tu Negocio', 'Chat Formé pour Votre Entreprise', 'Unternehmensspezifischer Chat', 'Chat Treinado para o Negócio', 'دردشة مدربة على نشاطك'),
    impact: localized('Answer Business-Specific Questions', 'İşletmeye Özel Soruları Yanıtla', 'Responde Preguntas Específicas del Negocio', 'Répondez aux Questions Propres à Votre Activité', 'Unternehmensspezifische Fragen Beantworten', 'Responda Perguntas Específicas do Negócio', 'أجب عن الأسئلة الخاصة بنشاطك'),
  },
  'WhatsApp auto replies': {
    name: localized('WhatsApp Auto Replies', 'WhatsApp Otomatik Yanıtları', 'Respuestas Automáticas de WhatsApp', 'Réponses Automatiques WhatsApp', 'Automatische WhatsApp-Antworten', 'Respostas Automáticas no WhatsApp', 'ردود واتساب التلقائية'),
    impact: localized('Respond Faster', 'Daha Hızlı Yanıt Ver', 'Responde Más Rápido', 'Répondez Plus Vite', 'Schneller Antworten', 'Responda Mais Rápido', 'استجب بشكل أسرع'),
  },
  'Lead qualification system': {
    name: localized('Lead Qualification System', 'Müşteri Adayı Nitelendirme Sistemi', 'Sistema de Calificación de Leads', 'Système de Qualification des Prospects', 'Lead-Qualifizierungssystem', 'Sistema de Qualificação de Leads', 'نظام تأهيل العملاء المحتملين'),
    impact: localized('Focus on Qualified Leads', 'Nitelikli Taleplere Odaklan', 'Céntrate en Leads Cualificados', 'Concentrez-vous sur les Prospects Qualifiés', 'Auf Qualifizierte Leads Konzentrieren', 'Foque em Leads Qualificados', 'ركز على العملاء المؤهلين'),
  },
  'Online booking': {
    name: localized('Online Booking', 'Online Rezervasyon', 'Reservas Online', 'Réservation en Ligne', 'Online-Buchung', 'Reserva Online', 'الحجز عبر الإنترنت'),
    impact: localized('Increase Bookings', 'Rezervasyonları Artır', 'Aumenta las Reservas', 'Augmentez les Réservations', 'Mehr Buchungen Erzielen', 'Aumente as Reservas', 'زد الحجوزات'),
  },
  'Online payments': {
    name: localized('Online Payments', 'Online Ödemeler', 'Pagos Online', 'Paiements en Ligne', 'Online-Zahlungen', 'Pagamentos Online', 'المدفوعات عبر الإنترنت'),
    impact: localized('Get Paid Faster', 'Daha Hızlı Ödeme Al', 'Cobra Más Rápido', 'Soyez Payé Plus Rapidement', 'Schneller Bezahlt Werden', 'Receba Mais Rápido', 'احصل على المدفوعات أسرع'),
  },
  'Quote system': {
    name: localized('Quote System', 'Teklif Sistemi', 'Sistema de Presupuestos', 'Système de Devis', 'Angebotssystem', 'Sistema de Orçamentos', 'نظام عروض الأسعار'),
    impact: localized('Simplify Sales', 'Satışı Kolaylaştır', 'Simplifica las Ventas', 'Simplifiez les Ventes', 'Vertrieb Vereinfachen', 'Simplifique as Vendas', 'بسّط المبيعات'),
  },
  'Extra language': {
    name: localized('Extra Language + RTL', 'Ek Dil + RTL', 'Idioma Adicional + RTL', 'Langue Supplémentaire + RTL', 'Zusätzliche Sprache + RTL', 'Idioma Adicional + RTL', 'لغة إضافية + RTL'),
    impact: localized('Reach New Markets, Including RTL Audiences', 'RTL Kitleler Dahil Yeni Pazarlara Ulaş', 'Llega a Nuevos Mercados, Incluidos los Públicos RTL', 'Atteignez de Nouveaux Marchés, y Compris les Publics RTL', 'Neue Märkte Erreichen, Einschließlich RTL-Zielgruppen', 'Alcance Novos Mercados, Incluindo Públicos RTL', 'الوصول إلى أسواق جديدة، بما في ذلك جمهور RTL'),
  },
  'Country-specific SEO': {
    name: localized('Country-Specific SEO', 'Ülkeye Özel SEO', 'SEO Específico por País', 'SEO Spécifique par Pays', 'Länderspezifisches SEO', 'SEO Específico por País', 'تهيئة SEO خاصة بالدولة'),
    impact: localized('Improve Local Visibility', 'Yerel Görünürlüğü Artır', 'Mejora la Visibilidad Local', 'Améliorez la Visibilité Locale', 'Lokale Sichtbarkeit Verbessern', 'Melhore a Visibilidade Local', 'حسّن الظهور المحلي'),
  },
  'Google Reviews': {
    name: localized('Google Reviews', 'Google Yorumları', 'Reseñas de Google', 'Avis Google', 'Google-Bewertungen', 'Avaliações do Google', 'تقييمات Google'),
    impact: localized('Build More Trust', 'Daha Fazla Güven Oluştur', 'Genera Más Confianza', 'Renforcez la Confiance', 'Mehr Vertrauen Aufbauen', 'Gere Mais Confiança', 'ابنِ مزيدًا من الثقة'),
  },
  'Instagram feed': {
    name: localized('Instagram Feed', 'Instagram Akışı', 'Feed de Instagram', 'Flux Instagram', 'Instagram-Feed', 'Feed do Instagram', 'موجز Instagram'),
    impact: localized('Keep Content Fresh', 'İçeriği Güncel Tut', 'Mantén el Contenido Actualizado', 'Gardez un Contenu Actualisé', 'Inhalte Aktuell Halten', 'Mantenha o Conteúdo Atualizado', 'حافظ على تحديث المحتوى'),
  },
  'Speed optimization': {
    name: localized('Speed Optimization', 'Hız Optimizasyonu', 'Optimización de Velocidad', 'Optimisation de la Vitesse', 'Geschwindigkeitsoptimierung', 'Otimização de Velocidade', 'تحسين السرعة'),
    impact: localized('Reduce Visitor Drop-Off', 'Ziyaretçi Kaybını Azalt', 'Reduce el Abandono de Visitantes', 'Réduisez l’Abandon des Visiteurs', 'Besucherabbrüche Reduzieren', 'Reduza o Abandono de Visitantes', 'قلّل مغادرة الزوار'),
  },
};

const careFeatures = [
  localized('Security and system updates', 'Güvenlik ve sistem güncellemeleri', 'Actualizaciones de seguridad y sistema', 'Mises à jour de sécurité et du système', 'Sicherheits- und Systemupdates', 'Atualizações de segurança e sistema', 'تحديثات الأمان والنظام'),
  localized('Basic maintenance', 'Temel bakım', 'Mantenimiento básico', 'Maintenance de base', 'Grundlegende Wartung', 'Manutenção básica', 'صيانة أساسية'),
  localized('Regular backups', 'Düzenli yedekleme', 'Copias de seguridad periódicas', 'Sauvegardes régulières', 'Regelmäßige Backups', 'Backups regulares', 'نسخ احتياطية منتظمة'),
  localized('Uptime checks', 'Çalışma süresi kontrolü', 'Comprobaciones de disponibilidad', 'Contrôles de disponibilité', 'Verfügbarkeitsprüfungen', 'Verificações de disponibilidade', 'فحوصات وقت التشغيل'),
  localized('Monthly small content updates', 'Aylık küçük içerik güncellemeleri', 'Pequeñas actualizaciones mensuales de contenido', 'Petites mises à jour mensuelles du contenu', 'Kleine monatliche Inhaltsupdates', 'Pequenas atualizações mensais de conteúdo', 'تحديثات شهرية بسيطة للمحتوى'),
  localized('Standard support', 'Standart destek', 'Soporte estándar', 'Support standard', 'Standard-Support', 'Suporte padrão', 'دعم قياسي'),
];

const growthFeatures = [
  localized('Everything in Care', 'Care planındaki her şey', 'Todo lo incluido en Care', 'Tout ce qui est inclus dans Care', 'Alles aus Care', 'Tudo do plano Care', 'كل ما يتضمنه Care'),
  localized('Regular performance checks', 'Düzenli performans kontrolü', 'Controles periódicos de rendimiento', 'Contrôles réguliers des performances', 'Regelmäßige Leistungsprüfungen', 'Verificações regulares de desempenho', 'فحوصات أداء منتظمة'),
  localized('SEO health checks', 'SEO sağlık kontrolleri', 'Revisiones de salud SEO', 'Contrôles de santé SEO', 'SEO-Gesundheitschecks', 'Verificações de saúde de SEO', 'فحوصات سلامة SEO'),
  localized('Analytics tracking', 'Analitik takibi', 'Seguimiento analítico', 'Suivi analytique', 'Analytics-Tracking', 'Acompanhamento de analytics', 'متابعة التحليلات'),
  localized('Conversion improvement suggestions', 'Dönüşüm geliştirme önerileri', 'Sugerencias para mejorar la conversión', 'Suggestions d’amélioration de la conversion', 'Vorschläge zur Conversion-Optimierung', 'Sugestões para melhorar conversões', 'اقتراحات لتحسين التحويل'),
  localized('Monthly content and section updates', 'Aylık içerik ve bölüm güncellemeleri', 'Actualizaciones mensuales de contenido y secciones', 'Mises à jour mensuelles du contenu et des sections', 'Monatliche Inhalts- und Abschnittsupdates', 'Atualizações mensais de conteúdo e seções', 'تحديثات شهرية للمحتوى والأقسام'),
  localized('Priority support', 'Öncelikli destek', 'Soporte prioritario', 'Support prioritaire', 'Priorisierter Support', 'Suporte prioritário', 'دعم ذو أولوية'),
];

const businessProFeatures = [
  localized('Everything in Growth', 'Growth planındaki her şey', 'Todo lo incluido en Growth', 'Tout ce qui est inclus dans Growth', 'Alles aus Growth', 'Tudo do plano Growth', 'كل ما يتضمنه Growth'),
  localized('Advanced technical support', 'Gelişmiş teknik destek', 'Soporte técnico avanzado', 'Support technique avancé', 'Erweiterter technischer Support', 'Suporte técnico avançado', 'دعم تقني متقدم'),
  localized('CRM and automation checks', 'CRM ve otomasyon kontrolleri', 'Revisiones de CRM y automatización', 'Contrôles du CRM et des automatisations', 'CRM- und Automatisierungsprüfungen', 'Verificações de CRM e automação', 'فحوصات CRM والأتمتة'),
  localized('Priority development time', 'Öncelikli geliştirme süresi', 'Tiempo de desarrollo prioritario', 'Temps de développement prioritaire', 'Priorisierte Entwicklungszeit', 'Tempo prioritário de desenvolvimento', 'وقت تطوير ذو أولوية'),
  localized('Monthly performance report', 'Aylık performans raporu', 'Informe mensual de rendimiento', 'Rapport mensuel de performance', 'Monatlicher Leistungsbericht', 'Relatório mensal de desempenho', 'تقرير أداء شهري'),
  localized('Conversion and UX review', 'Dönüşüm ve kullanıcı deneyimi incelemesi', 'Revisión de conversión y experiencia de usuario', 'Audit de conversion et d’expérience utilisateur', 'Conversion- und UX-Prüfung', 'Revisão de conversão e experiência do usuário', 'مراجعة التحويل وتجربة المستخدم'),
  localized('Integration monitoring', 'Entegrasyon takibi', 'Supervisión de integraciones', 'Surveillance des intégrations', 'Integrationsüberwachung', 'Monitoramento de integrações', 'مراقبة التكاملات'),
  localized('Highest support priority', 'En yüksek destek önceliği', 'Máxima prioridad de soporte', 'Priorité de support maximale', 'Höchste Support-Priorität', 'Máxima prioridade de suporte', 'أعلى أولوية للدعم'),
];

export const PLAN_CONTENT = {
  CARE: {
    name: localized('CARE', 'BAKIM', 'CUIDADO', 'SOIN', 'CARE', 'CUIDADO', 'العناية'),
    description: localized(
      'Your website stays secure, updated and reliable.',
      'Web siteniz güvenli, güncel ve güvenilir kalır.',
      'Tu sitio web se mantiene seguro, actualizado y fiable.',
      'Votre site reste sécurisé, à jour et fiable.',
      'Ihre Website bleibt sicher, aktuell und zuverlässig.',
      'Seu site permanece seguro, atualizado e confiável.',
      'يبقى موقعك آمنًا ومحدثًا وموثوقًا.'
    ),
    features: careFeatures,
  },
  GROWTH: {
    name: localized('GROWTH', 'BÜYÜME', 'CRECIMIENTO', 'CROISSANCE', 'WACHSTUM', 'CRESCIMENTO', 'النمو'),
    description: localized(
      'Continuous improvements designed to support business growth.',
      'İşletme büyümesini desteklemek için sürekli iyileştirmeler.',
      'Mejoras continuas diseñadas para apoyar el crecimiento del negocio.',
      'Des améliorations continues conçues pour soutenir la croissance de l’entreprise.',
      'Kontinuierliche Verbesserungen zur Unterstützung Ihres Unternehmenswachstums.',
      'Melhorias contínuas criadas para apoiar o crescimento do negócio.',
      'تحسينات مستمرة مصممة لدعم نمو الأعمال.'
    ),
    features: growthFeatures,
  },
  'BUSINESS PRO': {
    name: localized('BUSINESS PRO', 'İŞLETME PRO', 'NEGOCIO PRO', 'BUSINESS PRO', 'BUSINESS PRO', 'BUSINESS PRO', 'الأعمال الاحترافية'),
    description: localized(
      'Proactive management for business-critical web systems.',
      'İşletme açısından kritik web sistemleri için proaktif yönetim.',
      'Gestión proactiva para sistemas web críticos para el negocio.',
      'Gestion proactive des systèmes web essentiels à l’entreprise.',
      'Proaktives Management für geschäftskritische Websysteme.',
      'Gestão proativa para sistemas web críticos ao negócio.',
      'إدارة استباقية لأنظمة الويب الحيوية للأعمال.'
    ),
    features: businessProFeatures,
  },
};

export const PRICING_UI = {
  en: {
    pricingTitle: 'Choose the system your business needs today. Add more capabilities as you grow.',
    pricingSubtitle: 'No unnecessary features. No oversized agency fees. Just the tools your business actually needs.',
    modulesTitle: 'Add the Capabilities That Drive Growth',
    modulesSubtitle: 'Choose business outcomes, not unnecessary technical extras.',
    plansTitle: 'Monthly Care & Growth Plans',
    plansSubtitle: 'Ongoing support that keeps your website reliable and improving.',
    required: 'Ongoing support',
    startingAt: 'Starting from',
    oneTime: 'one-time',
    perMonth: '/month',
    popular: 'Popular',
    mostPopular: 'Most Popular',
    flexible: 'Flexible',
    selected: 'Selected',
    selectPackage: 'Select Package',
    selectPlan: 'Select Plan',
    buildPackage: 'Build Your Package',
    customDescription: 'Select only the modules you need. Your total is calculated from your choices.',
    customTitle: 'Build Your Custom Package',
    chooseFeatures: 'Select the features your business needs',
    selectedModules: 'Selected modules',
    selectedCount: 'Selected features',
    basePrice: 'Base price',
    estimatedTotal: 'Estimated starting total',
    estimateNotice: 'Estimated starting price. Final pricing depends on project scope and integrations.',
    addSelection: 'Continue to WhatsApp',
    moduleSingular: 'module',
    modulePlural: 'modules',
    quantity: 'Quantity',
    remove: 'Remove',
    cartCustomPackage: 'Custom Package',
    yourInformation: 'Your Information',
    selectPackageError: 'Please select a package first.',
    selectPlanError: 'Please select a monthly plan.',
    saveWarning: 'The request could not be saved, but WhatsApp has been opened.',
    requestReady: 'Your request is ready in WhatsApp.',
    customerDetails: 'Contact details',
    name: 'Name',
    business: 'Business',
    email: 'Email',
    phone: 'Phone',
  },
  tr: {
    pricingTitle: 'İşletmenizin bugün ihtiyaç duyduğu sistemi seçin. Büyüdükçe yeni özellikler ekleyin.',
    pricingSubtitle: 'Gereksiz özellikler ve yüksek ajans maliyetleri yok. Yalnızca işletmenizin gerçekten ihtiyaç duyduğu çözümler.',
    modulesTitle: 'Büyümeyi Sağlayan Özellikleri Ekleyin',
    modulesSubtitle: 'Gereksiz teknik eklentiler yerine işletmenize sağlayacağı sonucu seçin.',
    plansTitle: 'Aylık Bakım ve Büyüme Planları',
    plansSubtitle: 'Web sitenizi güvenilir ve sürekli gelişen halde tutan destek.',
    required: 'Sürekli destek',
    startingAt: 'Başlangıç fiyatı',
    oneTime: 'tek seferlik',
    perMonth: '/ay',
    popular: 'Popüler',
    mostPopular: 'En Popüler',
    flexible: 'Esnek',
    selected: 'Seçildi',
    selectPackage: 'Paketi Seç',
    selectPlan: 'Planı Seç',
    buildPackage: 'Paketini Oluştur',
    customDescription: 'Yalnızca ihtiyacınız olan modülleri seçin. Toplam, seçimlerinize göre hesaplanır.',
    customTitle: 'Özel Paketinizi Oluşturun',
    chooseFeatures: 'İşletmenizin ihtiyaç duyduğu özellikleri seçin',
    selectedModules: 'Seçilen modüller',
    selectedCount: 'Seçilen özellik',
    basePrice: 'Taban fiyat',
    estimatedTotal: 'Tahmini başlangıç toplamı',
    estimateNotice: 'Tahmini başlangıç fiyatıdır. Nihai fiyat proje kapsamına ve entegrasyonlara göre belirlenir.',
    addSelection: 'WhatsApp ile Devam Et',
    moduleSingular: 'modül',
    modulePlural: 'modül',
    quantity: 'Adet',
    remove: 'Kaldır',
    cartCustomPackage: 'Özel Paket',
    yourInformation: 'Bilgileriniz',
    selectPackageError: 'Lütfen önce bir paket seçin.',
    selectPlanError: 'Lütfen bir aylık plan seçin.',
    saveWarning: 'Talep kaydedilemedi ancak WhatsApp açıldı.',
    requestReady: 'Talebiniz WhatsApp’ta hazır.',
    customerDetails: 'İletişim bilgileri',
    name: 'Ad',
    business: 'İşletme',
    email: 'E-posta',
    phone: 'Telefon',
  },
  es: {
    pricingTitle: 'Elige el sistema que tu negocio necesita hoy. Añade más capacidades a medida que creces.',
    pricingSubtitle: 'Sin funciones innecesarias. Sin tarifas desproporcionadas de agencia. Solo las herramientas que tu negocio realmente necesita.',
    modulesTitle: 'Añade las Capacidades que Impulsan el Crecimiento',
    modulesSubtitle: 'Elige resultados para tu negocio, no extras técnicos innecesarios.',
    plansTitle: 'Planes Mensuales de Cuidado y Crecimiento',
    plansSubtitle: 'Soporte continuo para mantener tu web fiable y en mejora constante.',
    required: 'Soporte continuo',
    startingAt: 'Desde',
    oneTime: 'pago único',
    perMonth: '/mes',
    popular: 'Popular',
    mostPopular: 'Más Popular',
    flexible: 'Flexible',
    selected: 'Seleccionado',
    selectPackage: 'Seleccionar Paquete',
    selectPlan: 'Seleccionar Plan',
    buildPackage: 'Crear Tu Paquete',
    customDescription: 'Selecciona solo los módulos que necesitas. El total se calcula según tus elecciones.',
    customTitle: 'Crea Tu Paquete Personalizado',
    chooseFeatures: 'Selecciona las funciones que necesita tu negocio',
    selectedModules: 'Módulos seleccionados',
    selectedCount: 'Funciones seleccionadas',
    basePrice: 'Precio base',
    estimatedTotal: 'Total inicial estimado',
    estimateNotice: 'Precio inicial estimado. El precio final depende del alcance del proyecto y las integraciones.',
    addSelection: 'Continuar por WhatsApp',
    moduleSingular: 'módulo',
    modulePlural: 'módulos',
    quantity: 'Cantidad',
    remove: 'Eliminar',
    cartCustomPackage: 'Paquete Personalizado',
    yourInformation: 'Tus Datos',
    selectPackageError: 'Selecciona primero un paquete.',
    selectPlanError: 'Selecciona un plan mensual.',
    saveWarning: 'No se pudo guardar la solicitud, pero WhatsApp se ha abierto.',
    requestReady: 'Tu solicitud está lista en WhatsApp.',
    customerDetails: 'Datos de contacto',
    name: 'Nombre',
    business: 'Empresa',
    email: 'Email',
    phone: 'Teléfono',
  },
  fr: {
    pricingTitle: 'Choisissez le système dont votre entreprise a besoin aujourd’hui. Ajoutez des capacités au fil de votre croissance.',
    pricingSubtitle: 'Aucune fonction inutile. Aucun tarif d’agence surdimensionné. Seulement les outils réellement utiles à votre entreprise.',
    modulesTitle: 'Ajoutez les Capacités qui Stimulent la Croissance',
    modulesSubtitle: 'Choisissez des résultats concrets, pas des options techniques inutiles.',
    plansTitle: 'Plans Mensuels de Maintenance et de Croissance',
    plansSubtitle: 'Un accompagnement continu pour garder votre site fiable et performant.',
    required: 'Support continu',
    startingAt: 'À partir de',
    oneTime: 'paiement unique',
    perMonth: '/mois',
    popular: 'Populaire',
    mostPopular: 'Le Plus Populaire',
    flexible: 'Flexible',
    selected: 'Sélectionné',
    selectPackage: 'Choisir le Forfait',
    selectPlan: 'Choisir le Plan',
    buildPackage: 'Créer Votre Forfait',
    customDescription: 'Sélectionnez uniquement les modules nécessaires. Le total est calculé selon vos choix.',
    customTitle: 'Créez Votre Forfait Sur Mesure',
    chooseFeatures: 'Sélectionnez les fonctions dont votre entreprise a besoin',
    selectedModules: 'Modules sélectionnés',
    selectedCount: 'Fonctions sélectionnées',
    basePrice: 'Prix de base',
    estimatedTotal: 'Total de départ estimé',
    estimateNotice: 'Prix de départ estimé. Le prix final dépend du périmètre du projet et des intégrations.',
    addSelection: 'Continuer sur WhatsApp',
    moduleSingular: 'module',
    modulePlural: 'modules',
    quantity: 'Quantité',
    remove: 'Retirer',
    cartCustomPackage: 'Forfait Sur Mesure',
    yourInformation: 'Vos Informations',
    selectPackageError: 'Veuillez d’abord choisir un forfait.',
    selectPlanError: 'Veuillez choisir un plan mensuel.',
    saveWarning: 'La demande n’a pas pu être enregistrée, mais WhatsApp a été ouvert.',
    requestReady: 'Votre demande est prête dans WhatsApp.',
    customerDetails: 'Coordonnées',
    name: 'Nom',
    business: 'Entreprise',
    email: 'E-mail',
    phone: 'Téléphone',
  },
  de: {
    pricingTitle: 'Wählen Sie heute das System, das Ihr Unternehmen braucht. Ergänzen Sie weitere Funktionen, wenn Sie wachsen.',
    pricingSubtitle: 'Keine unnötigen Funktionen. Keine überhöhten Agenturkosten. Nur die Werkzeuge, die Ihr Unternehmen wirklich braucht.',
    modulesTitle: 'Funktionen für Mehr Wachstum Hinzufügen',
    modulesSubtitle: 'Wählen Sie Geschäftsergebnisse statt unnötiger technischer Extras.',
    plansTitle: 'Monatliche Pflege- und Wachstumspläne',
    plansSubtitle: 'Laufende Betreuung für eine zuverlässige und stetig bessere Website.',
    required: 'Laufende Betreuung',
    startingAt: 'Ab',
    oneTime: 'einmalig',
    perMonth: '/Monat',
    popular: 'Beliebt',
    mostPopular: 'Am Beliebtesten',
    flexible: 'Flexibel',
    selected: 'Ausgewählt',
    selectPackage: 'Paket Auswählen',
    selectPlan: 'Plan Auswählen',
    buildPackage: 'Paket Zusammenstellen',
    customDescription: 'Wählen Sie nur die benötigten Module. Die Summe wird aus Ihrer Auswahl berechnet.',
    customTitle: 'Individuelles Paket Zusammenstellen',
    chooseFeatures: 'Wählen Sie die Funktionen, die Ihr Unternehmen benötigt',
    selectedModules: 'Ausgewählte Module',
    selectedCount: 'Ausgewählte Funktionen',
    basePrice: 'Basispreis',
    estimatedTotal: 'Geschätzter Startpreis',
    estimateNotice: 'Geschätzter Startpreis. Der endgültige Preis hängt vom Projektumfang und den Integrationen ab.',
    addSelection: 'Über WhatsApp Fortfahren',
    moduleSingular: 'Modul',
    modulePlural: 'Module',
    quantity: 'Anzahl',
    remove: 'Entfernen',
    cartCustomPackage: 'Individuelles Paket',
    yourInformation: 'Ihre Angaben',
    selectPackageError: 'Bitte wählen Sie zuerst ein Paket.',
    selectPlanError: 'Bitte wählen Sie einen Monatsplan.',
    saveWarning: 'Die Anfrage konnte nicht gespeichert werden, WhatsApp wurde jedoch geöffnet.',
    requestReady: 'Ihre Anfrage ist in WhatsApp bereit.',
    customerDetails: 'Kontaktdaten',
    name: 'Name',
    business: 'Unternehmen',
    email: 'E-Mail',
    phone: 'Telefon',
  },
  pt: {
    pricingTitle: 'Escolha hoje o sistema de que sua empresa precisa. Adicione mais recursos conforme cresce.',
    pricingSubtitle: 'Sem recursos desnecessários. Sem taxas exageradas de agência. Apenas as ferramentas de que sua empresa realmente precisa.',
    modulesTitle: 'Adicione os Recursos que Geram Crescimento',
    modulesSubtitle: 'Escolha resultados para o negócio, não extras técnicos desnecessários.',
    plansTitle: 'Planos Mensais de Cuidado e Crescimento',
    plansSubtitle: 'Suporte contínuo para manter seu site confiável e sempre melhorando.',
    required: 'Suporte contínuo',
    startingAt: 'A partir de',
    oneTime: 'pagamento único',
    perMonth: '/mês',
    popular: 'Popular',
    mostPopular: 'Mais Popular',
    flexible: 'Flexível',
    selected: 'Selecionado',
    selectPackage: 'Selecionar Pacote',
    selectPlan: 'Selecionar Plano',
    buildPackage: 'Montar Seu Pacote',
    customDescription: 'Selecione apenas os módulos necessários. O total é calculado conforme suas escolhas.',
    customTitle: 'Monte Seu Pacote Personalizado',
    chooseFeatures: 'Selecione os recursos de que sua empresa precisa',
    selectedModules: 'Módulos selecionados',
    selectedCount: 'Recursos selecionados',
    basePrice: 'Preço base',
    estimatedTotal: 'Total inicial estimado',
    estimateNotice: 'Preço inicial estimado. O preço final depende do escopo do projeto e das integrações.',
    addSelection: 'Continuar pelo WhatsApp',
    moduleSingular: 'módulo',
    modulePlural: 'módulos',
    quantity: 'Quantidade',
    remove: 'Remover',
    cartCustomPackage: 'Pacote Personalizado',
    yourInformation: 'Seus Dados',
    selectPackageError: 'Selecione primeiro um pacote.',
    selectPlanError: 'Selecione um plano mensal.',
    saveWarning: 'Não foi possível salvar a solicitação, mas o WhatsApp foi aberto.',
    requestReady: 'Sua solicitação está pronta no WhatsApp.',
    customerDetails: 'Dados de contato',
    name: 'Nome',
    business: 'Empresa',
    email: 'E-mail',
    phone: 'Telefone',
  },
  ar: {
    pricingTitle: 'اختر اليوم النظام الذي يحتاجه عملك. أضف المزيد من الإمكانات مع نموك.',
    pricingSubtitle: 'لا ميزات غير ضرورية ولا رسوم وكالات مبالغ فيها. فقط الأدوات التي يحتاجها عملك فعلًا.',
    modulesTitle: 'أضف الإمكانات التي تدعم النمو',
    modulesSubtitle: 'اختر نتائج الأعمال، لا الإضافات التقنية غير الضرورية.',
    plansTitle: 'خطط العناية والنمو الشهرية',
    plansSubtitle: 'دعم مستمر يحافظ على موثوقية موقعك وتطوره.',
    required: 'دعم مستمر',
    startingAt: 'يبدأ من',
    oneTime: 'دفعة واحدة',
    perMonth: '/شهر',
    popular: 'شائع',
    mostPopular: 'الأكثر شيوعًا',
    flexible: 'مرن',
    selected: 'تم الاختيار',
    selectPackage: 'اختر الباقة',
    selectPlan: 'اختر الخطة',
    buildPackage: 'أنشئ باقتك',
    customDescription: 'اختر الوحدات التي تحتاجها فقط. يُحسب الإجمالي حسب اختياراتك.',
    customTitle: 'أنشئ باقتك المخصصة',
    chooseFeatures: 'اختر الميزات التي يحتاجها عملك',
    selectedModules: 'الوحدات المختارة',
    selectedCount: 'الميزات المختارة',
    basePrice: 'السعر الأساسي',
    estimatedTotal: 'الإجمالي التقديري للبدء',
    estimateNotice: 'سعر تقديري للبدء. يعتمد السعر النهائي على نطاق المشروع والتكاملات.',
    addSelection: 'المتابعة عبر واتساب',
    moduleSingular: 'وحدة',
    modulePlural: 'وحدات',
    quantity: 'العدد',
    remove: 'إزالة',
    cartCustomPackage: 'باقة مخصصة',
    yourInformation: 'بياناتك',
    selectPackageError: 'يرجى اختيار باقة أولًا.',
    selectPlanError: 'يرجى اختيار خطة شهرية.',
    saveWarning: 'تعذر حفظ الطلب، لكن تم فتح واتساب.',
    requestReady: 'طلبك جاهز في واتساب.',
    customerDetails: 'بيانات التواصل',
    name: 'الاسم',
    business: 'النشاط',
    email: 'البريد الإلكتروني',
    phone: 'الهاتف',
  },
};

const localeByLanguage = {
  en: 'en-US',
  tr: 'tr-TR',
  es: 'es-ES',
  fr: 'fr-FR',
  de: 'de-DE',
  pt: 'pt-PT',
  ar: 'ar',
};

export const getPricingCopy = (language) => PRICING_UI[language] || PRICING_UI.en;

export const getLocalizedContent = (content, language) => content?.[language] ?? '';

export const formatUSD = (value, language = 'en') =>
  new Intl.NumberFormat(localeByLanguage[language] || localeByLanguage.en, {
    style: 'currency',
    currency: 'USD',
    currencyDisplay: 'narrowSymbol',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export const calculateModuleTotal = (modules = []) =>
  modules.reduce(
    (total, module) =>
      total + Number(module.price || 0) * Number(module.quantity || 1),
    0
  );

export const calculateCustomTotal = (basePrice, modules = []) =>
  Number(basePrice || 0) + calculateModuleTotal(modules);

export const expandModuleIds = (modules = []) =>
  modules.flatMap((module) =>
    Array(Number(module.quantity || 1)).fill(module.id)
  );

export const updateModuleQuantity = (modules = [], moduleId, nextQuantity) => {
  if (nextQuantity <= 0) {
    return modules.filter((module) => module.id !== moduleId);
  }
  return modules.map((module) =>
    module.id === moduleId
      ? { ...module, quantity: nextQuantity }
      : module
  );
};

export const getPackageContent = (canonicalName, language) => {
  const content = PACKAGE_CONTENT[canonicalName];
  if (!content) return null;
  return {
    name: getLocalizedContent(content.name, language),
    target: getLocalizedContent(content.target, language),
    impacts: (content.impacts || []).map((impact) => getLocalizedContent(impact, language)),
  };
};

export const getModuleContent = (canonicalName, language) => {
  const content = MODULE_CONTENT[canonicalName];
  if (!content) return null;
  return {
    name: getLocalizedContent(content.name, language),
    impact: getLocalizedContent(content.impact, language),
  };
};

export const getPlanContent = (canonicalName, language) => {
  const content = PLAN_CONTENT[canonicalName];
  if (!content) return null;
  return {
    name: getLocalizedContent(content.name, language),
    description: getLocalizedContent(content.description, language),
    features: content.features.map((feature) => getLocalizedContent(feature, language)),
  };
};

export const getCategoryContent = (canonicalName, language) =>
  getLocalizedContent(CATEGORY_CONTENT[canonicalName], language);

const whatsappTemplates = {
  en: {
    standard: (packageName, price) =>
      `Hi, I’m interested in the ${packageName} package starting at ${price}. I’d like to discuss my business requirements and receive a detailed proposal.`,
    customIntro: 'Hi, I’m interested in a custom Webouse solution.',
    base: 'Base price',
    modules: 'Selected modules',
    estimated: 'Estimated starting total',
    customOutro: 'I’d like to discuss my project requirements and receive a detailed proposal.',
    plan: (planName, price, month) =>
      `Hi, I’m interested in the ${planName} monthly plan at ${price}${month}. I’d like to learn more about the included support and services.`,
  },
  tr: {
    standard: (packageName, price) =>
      `Merhaba, başlangıç fiyatı ${price} olan ${packageName} paketiyle ilgileniyorum. İşletmemin ihtiyaçlarını görüşmek ve ayrıntılı bir teklif almak istiyorum.`,
    customIntro: 'Merhaba, işletmeme özel bir Webouse çözümüyle ilgileniyorum.',
    base: 'Taban fiyat',
    modules: 'Seçilen modüller',
    estimated: 'Tahmini başlangıç toplamı',
    customOutro: 'Proje ihtiyaçlarımı görüşmek ve ayrıntılı bir teklif almak istiyorum.',
    plan: (planName, price, month) =>
      `Merhaba, ${price}${month} fiyatlı ${planName} aylık planıyla ilgileniyorum. Dahil olan destek ve hizmetler hakkında daha fazla bilgi almak istiyorum.`,
  },
  es: {
    standard: (packageName, price) =>
      `Hola, me interesa el paquete ${packageName} con un precio inicial de ${price}. Me gustaría hablar sobre las necesidades de mi negocio y recibir una propuesta detallada.`,
    customIntro: 'Hola, me interesa una solución Webouse personalizada.',
    base: 'Precio base',
    modules: 'Módulos seleccionados',
    estimated: 'Total inicial estimado',
    customOutro: 'Me gustaría hablar sobre los requisitos de mi proyecto y recibir una propuesta detallada.',
    plan: (planName, price, month) =>
      `Hola, me interesa el plan mensual ${planName} por ${price}${month}. Me gustaría saber más sobre el soporte y los servicios incluidos.`,
  },
  fr: {
    standard: (packageName, price) =>
      `Bonjour, je suis intéressé par le forfait ${packageName} à partir de ${price}. Je souhaite discuter des besoins de mon entreprise et recevoir une proposition détaillée.`,
    customIntro: 'Bonjour, je suis intéressé par une solution Webouse sur mesure.',
    base: 'Prix de base',
    modules: 'Modules sélectionnés',
    estimated: 'Total de départ estimé',
    customOutro: 'Je souhaite discuter des besoins de mon projet et recevoir une proposition détaillée.',
    plan: (planName, price, month) =>
      `Bonjour, je suis intéressé par le plan mensuel ${planName} à ${price}${month}. Je souhaite en savoir plus sur le support et les services inclus.`,
  },
  de: {
    standard: (packageName, price) =>
      `Hallo, ich interessiere mich für das Paket ${packageName} ab ${price}. Ich möchte meine geschäftlichen Anforderungen besprechen und ein detailliertes Angebot erhalten.`,
    customIntro: 'Hallo, ich interessiere mich für eine individuelle Webouse-Lösung.',
    base: 'Basispreis',
    modules: 'Ausgewählte Module',
    estimated: 'Geschätzter Startpreis',
    customOutro: 'Ich möchte meine Projektanforderungen besprechen und ein detailliertes Angebot erhalten.',
    plan: (planName, price, month) =>
      `Hallo, ich interessiere mich für den Monatsplan ${planName} für ${price}${month}. Ich möchte mehr über die enthaltene Betreuung und die Leistungen erfahren.`,
  },
  pt: {
    standard: (packageName, price) =>
      `Olá, tenho interesse no pacote ${packageName}, com preço inicial de ${price}. Gostaria de conversar sobre as necessidades da minha empresa e receber uma proposta detalhada.`,
    customIntro: 'Olá, tenho interesse em uma solução Webouse personalizada.',
    base: 'Preço base',
    modules: 'Módulos selecionados',
    estimated: 'Total inicial estimado',
    customOutro: 'Gostaria de conversar sobre os requisitos do meu projeto e receber uma proposta detalhada.',
    plan: (planName, price, month) =>
      `Olá, tenho interesse no plano mensal ${planName} por ${price}${month}. Gostaria de saber mais sobre o suporte e os serviços incluídos.`,
  },
  ar: {
    standard: (packageName, price) =>
      `مرحبًا، أنا مهتم بباقة ${packageName} التي يبدأ سعرها من ${price}. أود مناقشة احتياجات عملي والحصول على عرض تفصيلي.`,
    customIntro: 'مرحبًا، أنا مهتم بحل Webouse مخصص.',
    base: 'السعر الأساسي',
    modules: 'الوحدات المختارة',
    estimated: 'الإجمالي التقديري للبدء',
    customOutro: 'أود مناقشة متطلبات مشروعي والحصول على عرض تفصيلي.',
    plan: (planName, price, month) =>
      `مرحبًا، أنا مهتم بالخطة الشهرية ${planName} بسعر ${price}${month}. أود معرفة المزيد عن الدعم والخدمات المشمولة.`,
  },
};

const buildPricingWhatsAppMessageLegacy = ({
  language,
  selectedPackage,
  selectedAddons = [],
  selectedPlan,
  customerInfo,
  oneTimeTotal,
}) => {
  const lang = PRICING_LANGUAGES.includes(language) ? language : 'en';
  const template = whatsappTemplates[lang];
  const ui = PRICING_UI[lang];
  const sections = [];

  if (selectedPackage?.isCustom) {
    const moduleLines = (selectedPackage.modules || []).map((module) => {
      const quantity = module.quantity || 1;
      const lineTotal = Number(module.price || 0) * quantity;
      const quantityLabel = quantity > 1 ? ` × ${quantity}` : '';
      return `• ${module.name}${quantityLabel} — ${formatUSD(lineTotal, lang)}`;
    });
    sections.push([
      template.customIntro,
      '',
      `${template.base}: ${formatUSD(selectedPackage.basePrice, lang)}`,
      '',
      `${template.modules}:`,
      '',
      ...moduleLines,
      '',
      `${template.estimated}: ${formatUSD(selectedPackage.price, lang)}`,
      '',
      template.customOutro,
    ].join('\n'));
  } else if (selectedPackage) {
    sections.push(template.standard(
      selectedPackage.name,
      formatUSD(selectedPackage.price, lang)
    ));

    if (selectedAddons.length) {
      const addonLines = selectedAddons.map((module) => {
        const quantity = module.quantity || 1;
        const lineTotal = Number(module.price || 0) * quantity;
        const quantityLabel = quantity > 1 ? ` × ${quantity}` : '';
        return `• ${module.name}${quantityLabel} — ${formatUSD(lineTotal, lang)}`;
      });
      sections.push([
        `${template.modules}:`,
        '',
        ...addonLines,
        '',
        `${template.estimated}: ${formatUSD(oneTimeTotal, lang)}`,
      ].join('\n'));
    }
  }

  if (selectedPlan) {
    sections.push(template.plan(
      selectedPlan.name,
      formatUSD(selectedPlan.price, lang),
      ui.perMonth
    ));
  }

  if (customerInfo?.name || customerInfo?.business || customerInfo?.email || customerInfo?.phone) {
    sections.push([
      `${ui.customerDetails}:`,
      customerInfo.name ? `${ui.name}: ${customerInfo.name}` : null,
      customerInfo.business ? `${ui.business}: ${customerInfo.business}` : null,
      customerInfo.email ? `${ui.email}: ${customerInfo.email}` : null,
      customerInfo.phone ? `${ui.phone}: ${customerInfo.phone}` : null,
    ].filter(Boolean).join('\n'));
  }

  return sections.join('\n\n');
};

export const buildPricingWhatsAppMessage = (options) => {
  const hasRegionalPricing =
    options?.pricingRegion ||
    options?.currencyCode ||
    options?.displayedOneTimeTotal !== undefined ||
    options?.displayedMonthlyTotal !== undefined ||
    options?.monthlyTotal !== undefined ||
    typeof options?.formatPrice === 'function';

  if (!hasRegionalPricing) {
    return buildPricingWhatsAppMessageLegacy(options);
  }

  const {
    language,
    selectedPackage,
    selectedAddons = [],
    selectedPlan,
    customerInfo,
    oneTimeTotal,
    monthlyTotal,
    pricingRegion,
    currencyCode,
    displayedOneTimeTotal,
    displayedMonthlyTotal,
    formatPrice,
  } = options;
  const lang = PRICING_LANGUAGES.includes(language) ? language : 'en';
  const template = whatsappTemplates[lang];
  const ui = PRICING_UI[lang];
  const formatDisplayedPrice =
    typeof formatPrice === 'function'
      ? formatPrice
      : (value) => formatUSD(value, lang);
  const sections = [];

  if (selectedPackage?.isCustom) {
    const moduleLines = (selectedPackage.modules || []).map((module) => {
      const quantity = module.quantity || 1;
      const lineTotal = Number(module.price || 0) * quantity;
      const quantityLabel = quantity > 1 ? ` x ${quantity}` : '';
      return `- ${module.name}${quantityLabel}: ${formatDisplayedPrice(lineTotal)}`;
    });
    sections.push([
      template.customIntro,
      '',
      `${template.base}: ${formatDisplayedPrice(selectedPackage.basePrice)}`,
      '',
      `${template.modules}:`,
      ...moduleLines,
      '',
      `${template.estimated}: ${formatDisplayedPrice(selectedPackage.price)}`,
      '',
      template.customOutro,
    ].join('\n'));
  } else if (selectedPackage) {
    sections.push(template.standard(
      selectedPackage.name,
      formatDisplayedPrice(selectedPackage.price)
    ));

    if (selectedAddons.length) {
      const addonLines = selectedAddons.map((module) => {
        const quantity = module.quantity || 1;
        const lineTotal = Number(module.price || 0) * quantity;
        const quantityLabel = quantity > 1 ? ` x ${quantity}` : '';
        return `- ${module.name}${quantityLabel}: ${formatDisplayedPrice(lineTotal)}`;
      });
      sections.push([
        `${template.modules}:`,
        ...addonLines,
        '',
        `${template.estimated}: ${formatDisplayedPrice(oneTimeTotal)}`,
      ].join('\n'));
    }
  }

  if (selectedPlan) {
    sections.push(template.plan(
      selectedPlan.name,
      formatDisplayedPrice(selectedPlan.price),
      ui.perMonth
    ));
  }

  if (customerInfo?.name || customerInfo?.business || customerInfo?.email || customerInfo?.phone) {
    sections.push([
      `${ui.customerDetails}:`,
      customerInfo.name ? `${ui.name}: ${customerInfo.name}` : null,
      customerInfo.business ? `${ui.business}: ${customerInfo.business}` : null,
      customerInfo.email ? `${ui.email}: ${customerInfo.email}` : null,
      customerInfo.phone ? `${ui.phone}: ${customerInfo.phone}` : null,
    ].filter(Boolean).join('\n'));
  }

  sections.push([
    'Displayed pricing:',
    pricingRegion ? `Region: ${pricingRegion}` : null,
    currencyCode ? `Currency: ${currencyCode}` : null,
    displayedOneTimeTotal !== undefined
      ? `One-time: ${formatDisplayedPrice(displayedOneTimeTotal)}`
      : null,
    displayedMonthlyTotal !== undefined || monthlyTotal !== undefined
      ? `Monthly: ${formatDisplayedPrice(displayedMonthlyTotal ?? monthlyTotal)}${ui.perMonth}`
      : null,
  ].filter(Boolean).join('\n'));

  return sections.join('\n\n');
};

export const createFallbackPackages = () =>
  Object.entries(DEFAULT_PRICES.packages).map(([name, price], order) => ({
    id: `fallback-package-${name.toLowerCase()}`,
    name,
    price,
    order,
    is_custom: name === 'CUSTOM',
    is_popular: name === 'BUILD',
  }));

export const createFallbackModuleGroups = () => {
  const categoryByModule = {
    'Smart website chat': 'Customer Engagement',
    'Business-trained chat': 'Customer Engagement',
    'WhatsApp auto replies': 'Customer Engagement',
    'Lead qualification system': 'Customer Engagement',
    'Online booking': 'Sales',
    'Online payments': 'Sales',
    'Quote system': 'Sales',
    'Extra language': 'Global',
    'Country-specific SEO': 'Global',
    'Google Reviews': 'Visibility',
    'Instagram feed': 'Visibility',
    'Speed optimization': 'Visibility',
  };

  return Object.keys(CATEGORY_CONTENT).map((categoryName, categoryIndex) => ({
    category: {
      id: `fallback-category-${categoryIndex}`,
      name: categoryName,
    },
    modules: Object.entries(DEFAULT_PRICES.modules)
      .filter(([moduleName]) => categoryByModule[moduleName] === categoryName)
      .map(([name, price], moduleIndex) => ({
        id: `fallback-module-${categoryIndex}-${moduleIndex}`,
        name,
        price,
      })),
  }));
};

export const createFallbackPlans = () =>
  Object.entries(DEFAULT_PRICES.plans).map(([name, price], order) => ({
    id: `fallback-plan-${name.toLowerCase().replace(/\s+/g, '-')}`,
    name,
    price,
    order,
    is_popular: name === 'GROWTH',
  }));
